import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import withBrowserHistory from 'modules/shell/hoc/withBrowserHistory';

import styles from './OrderHistoryCard.styles';
import OrderHistoryCard from './OrderHistoryCard';

export default compose(
  withBrowserHistory(),
  withStyles(styles),
)(OrderHistoryCard);
